<template>
  <section>
    <p-celebration-column></p-celebration-column>
  </section>
</template>
<script>
import PCelebrationColumn from './pc/PCelebrationColumn'
export default {
  components: {
    PCelebrationColumn
  },
}
</script>
<style lang="less">

</style>
